import React, {useContext} from 'react'
import {Menu, UserCircle} from 'lucide-react'
import {Link} from 'react-router-dom'
import HeaderTitle from './HeaderTitle'
import {API_URL} from "../../services/apiService";
import {FamilyContext} from "../../Context/FamilyHeadContext";

const MobileHeader = ({
                          toggleMobileMenu,
                          activeStyle,
                          commonClasses,
                          navigate,
                      }) => {
    const {currentFamilyHead, headerStyle} = useContext(FamilyContext)
    const {pathPrefix} = useContext(FamilyContext)

    return (
        <>
            {/* Mobile Layout */}
            <div className="nav-break:hidden h-full">
                <div className="flex items-center justify-center min-h-[100px]">
                    <button
                        onClick={toggleMobileMenu}
                        className={`${commonClasses.menuButton} absolute right-1 top-4`}
                    >
                        <Menu className="w-10 h-10 text-[#8B5E3C]"/>
                    </button>

                    <div className="flex items-center justify-center gap-2">
                        {/* הצגת/הסתרת לוגו */}
                        {!headerStyle?.settings?.hideLogo && (
                            <Link to={`${pathPrefix}`}
                                  className="cursor-pointer hover:text-[#698fb8] transition-colors duration-300">
                                {currentFamilyHead.images?.[0]?.key ? (
                                    <img
                                        crossOrigin="use-credentials"
                                        src={`${API_URL}/image/download/${encodeURIComponent(currentFamilyHead.images[0].key)}`}
                                        alt={currentFamilyHead.name}
                                        className={`w-16 h-16 mr-6 ${commonClasses.logo}`}
                                        onClick={() => navigate('/')}
                                    />
                                ) : (
                                    <UserCircle className="w-16 h-16 mr-6"/>
                                )}
                            </Link>
                        )}

                        <div>
                            {/* כותרת מותאמת או מקורית */}
                            {headerStyle?.settings?.customTitle ? (
                                <h3 className="text-subtitle-xl sm:text-subtitle-md lg:text-subtitle-lg text-[#5C4033] font-heebo text-center">
                                    {headerStyle.settings.customTitle}
                                </h3>
                            ) : (
                                <>
                                    <h3 className="text-subtitle-xl sm:text-subtitle-md lg:text-subtitle-lg text-[#5C4033] font-heebo text-center">
                                        {activeStyle.headerText}
                                    </h3>
                                    <HeaderTitle title={activeStyle.title}/>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobileHeader